import React, { useState, useEffect } from "react";
import axios from "axios";
import "../Assests/Scss/StudentFeedback.scss";
import Star from "../Reusablecomponents/Star";
import CopyRight from "../Reusablecomponents/Copyright";
import InternetChecking from "../Reusablecomponents/Network";
import Loading from "../Reusablecomponents/Loading";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaAnglesLeft } from "react-icons/fa6";

const StudentFeedback = () => {
    const navigate = useNavigate();
    const items =  useSelector((state) => state.userDetailsData.LoginDetails);
    const [FeedbackQuestions, SetFeedbackQuestions] = useState();
    const [Feedbackrating, SetFeedbackrating] = useState();
    const [rating, setRating] = useState(0);
    const [Load, SetLoad] = useState(false);
    const [TextBox, SeTextbox] = useState();
    const handleClick = async (index, Questionid) => {
        // rating.findIndex(obj => obj.subjectName === Subname)
        // if (Feedbackrating?.length > FeedbackQuestions?.length) {
        //     alert("Already submited the feed back")
        // } else {
            setRating({ ...rating, [Questionid]: index })
            if (rating.hasOwnProperty(Questionid)) {
                await axios.get(process.env.REACT_APP_API_BASE_URL + `/StudentResults/GetStudentQuestionFeedback?Userid=${items.userId}`, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
                    .then((res) => {
                        const val = res.data.findIndex(obj => obj.feedbackQuestionId === Questionid)
                        Updatefeedback(Questionid, index, res.data[val]?.id);
                    })
                    .catch(err => console.log(err));

                // const val = Feedbackrating.findIndex(obj => obj.feedbackQuestionId === Questionid)
                // Updatefeedback(Questionid, index, Feedbackrating[val]?.id);
            } else {
                InsertStudentFeedback(Questionid, index);
            }
        //}
    };

    const Updatefeedback = async (Questionid, index, ID) => {
        const updatedata = {
            "id": ID,
            "userId": items?.userId,
            "feedbackQuestionId": Questionid,
            "feedback": index.toString(),
        }

        await axios.post(process.env.REACT_APP_API_BASE_URL + `/StudentResults/UpdateStudentAssessmentFeedBack`, updatedata, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => { })
            .catch((err) => console.log(err))
    };


    const GetSQFeedback = async () => {
        SetLoad((prev) => !prev);

        await axios.get(process.env.REACT_APP_API_BASE_URL + `/StudentResults/GetStudentQuestionFeedback?Userid=${items?.userId}`, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                SetFeedbackrating(res.data);
                {
                    res.data.map((item, index) => {
                        setRating(prevState => ({
                            ...prevState, [item.feedbackQuestionId]: item.feedback
                        }))
                        if (item.feedbackQuestionId === 12) {
                            SeTextbox(item.feedback);
                        }
                    })
                }
                SetLoad((prev) => !prev);
            })
            .catch((err) => { console.log(err) })
    };

    const InsertStudentFeedback = async (Questionid, index) => {
        const Feedbackdata = {
            "userId": items?.userId,
            "feedbackQuestionId": Questionid,
            "feedback": index.toString(),
        }
        await axios.post(process.env.REACT_APP_API_BASE_URL + `/StudentResults/InsertStudentAssessmentFeedBack`, Feedbackdata, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {  })
            .catch(err => console.log(err))
    };

    const GetSTudentfeedback = async () => {
        SetLoad((prev) => !prev);

        await axios.get(process.env.REACT_APP_API_BASE_URL + `/StudentResults/GetFeedbackQuestions`, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                SetFeedbackQuestions(res.data);
                SetLoad((prev) => !prev);
            })
            .catch(err => console.log(err))
    };


    useEffect(() => {
        GetSTudentfeedback();
        GetSQFeedback();
    }, [])

    const SubmitFeedback = async () => {
        if (rating.hasOwnProperty(FeedbackQuestions?.length) ? Object.keys(rating).length === FeedbackQuestions.length : Object.keys(rating).length === FeedbackQuestions.length - 1) {

            const Feedbackdatasubmit = {
                "UserId": items?.userId,
                "IsFeedbackSubmitted": 1,
            }
            await axios.post(process.env.REACT_APP_API_BASE_URL + `/StudentResults/UpdateFeedbackSubmitted`, Feedbackdatasubmit, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
                .then((res) => {
                    GetSQFeedback();
                    alert("Feedback submitted successfully");

                })
                .catch((err) => {
                    alert("Please rate all the questions");
                })
        }
        else {
            alert("Please rate all the questions");
        }


        // if (Object.keys(rating).length === Feedbackrating.length) {
        //     navigate("/Dashboard", { replace: true });
        //     alert("The feedback form have submited successfully");
        // } else {
        //     alert("Please rate all the questions")
        // }
    };

    return (
        <>
            <div className="Instructions-pages SFeedback-maindiv">
                <InternetChecking />
                <div className="Buttons BackNavigation mb-2" style={{float: "right"}} onClick={()=> navigate(`/Dashboard`, { replace: true })}><FaAnglesLeft /> Back to dashboard </div>

                <h6>Student Feedback</h6>
                <p>Rate the Assessments on a scale of 1 to 5 star (1 star being the lowest and 5 star being the highest)</p>
                {FeedbackQuestions?.map((Question, Questionindex) => (
                    <div className="Feedback-questions dflex alignitems JSBetween">
                        <div> (Q{Questionindex + 1}) {Question.question}</div>
                        {Question.questionType !== "D" &&
                            <div className="SFRating">   {[1, 2, 3, 4, 5].map((_, index) => (
                                <Star
                                    key={index}
                                    filled={index < rating[Question.questionId]}
                                    block={Feedbackrating?.length === FeedbackQuestions?.length}
                                    onClick={() => handleClick(index + 1, Question.questionId)}
                                />
                            ))}</div>}
                    </div>))}
                <div className="dflex JSBetween Text-Button " style={{ alignItems: "flex-end" }}>
                    <textarea placeholder="Enter comments up to 150 characters"
                        onChange={(e) => SeTextbox(e.target.value)} value={TextBox} rows="3"
                        disabled={Feedbackrating?.length > FeedbackQuestions?.length || Feedbackrating?.length <FeedbackQuestions?.length}
                        onBlur={(e) => handleClick(e.target.value, FeedbackQuestions[FeedbackQuestions.length - 1]?.questionId)}
                    />
                    {Feedbackrating?.length < FeedbackQuestions?.length && <button className="Buttons" onClick={SubmitFeedback}>Submit Feedback</button>}</div>
                    <CopyRight />
                {Load && <Loading />}
            </div>
        </>
    )
};
export default StudentFeedback;